import styled from 'styled-components';

export const SlideWrapper = styled.div`
  min-width: 100%;
  height: 100%;
`;

export const SpinWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledImg = styled.img<{ $hide: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: ${(props) => (props.$hide ? 'none' : 'block')};
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 770px;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 10%);
`;

export const CarouselTrack = styled.div<{ $currentIndex: number }>`
  width: 100%;
  display: flex;
  transition: transform 500ms ease-in-out;
  transform: translateX(-${(props) => props.$currentIndex * 100}%);
`;

export const CarouselIndexes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 70px;
  padding: 10px 24px;
  gap: 20px;
  align-self: stretch;
  background: linear-gradient(0deg, rgb(0 70 255 / 17%) 0%, rgb(0 70 255 / 17%) 100%), #fff;
`;

export const CarouselIndex = styled.div`
  width: 50px;
  height: 50px;
  color: #000;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-content: center;
`;

export const SlideContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const SlideTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
`;

export const SlideDescription = styled.div`
  font-size: 16px;
  line-height: 24px;
`;
export const CarouselButtons = styled.div`
  display: flex;
  width: 80px;
  justify-content: space-between;
  align-items: center;
`;
export const CarouselButton = styled.button<{ $position: 'prev' | 'next' }>`
  ${(props) => (props.$position === 'prev' ? 'left: 1rem;' : 'right: 1rem;')}
  background-color: rgb(255 255 255 / 50%);
  color: #0046ff;
  border: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 200ms;
  backdrop-filter: blur(4px);

  &:hover {
    background-color: rgb(255 255 255 / 75%);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
